import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const addDropDownReviewSectionSelector = createSelector(testTargetOffersSelector, offers => offers.addDropDownReviewSection || Empty.Object);

export { addDropDownReviewSectionSelector };
